<template>
  <div class="chart" :class="{ 'chart--social-mode': socialMode, 'chart--no-footer': noFooter, 'chart--active-route-view': isActiveRouteView }">
    <component :is="chart" :socialMode="socialMode" ></component>
    <embeddable-footer v-if="showFooter" class="position-absolute" />
  </div>
</template>

<script>
import { EmbeddableFooter } from '@icij/murmur'
import find from 'lodash/find'
import { routes, ChartRoute } from '../router'

export default {
  name: 'Chart',
  components: {
    EmbeddableFooter
  },
  props: {
    chart: {
      type: Object
    },
    socialMode: {
      type: Boolean
    },
    noFooter: {
      type: Boolean
    }
  },
  computed: {
    showFooter () {
      return !this.noFooter && !this.socialMode
    },
    isActiveRouteView () {
      const route = find(routes, { name: this.$route.name })
      return route instanceof ChartRoute
    }
  }
}
</script>

<style lang="scss">
  .chart {
    position: relative;
    padding-bottom: 56px;

    &--active-route-view {
      min-height: 100vh;
    }

    &--social-mode {
      padding-bottom: 0;
      background: #212529;
      color: white;
    }

    &--no-footer {
      padding-bottom: 0;
    }
  }
</style>
